import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { action, computed, makeObservable, observable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
export let AbMouseOverListener = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, observer(_class = (_class2 = class AbMouseOverListener extends React.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "_isMouseOver", _descriptor, this);
    _defineProperty(this, "_element", null);
    makeObservable(this);
  }
  get element() {
    return this._element;
  }
  render() {
    return /*#__PURE__*/React.createElement("div", _extends({}, this.props, {
      ref: this.ref
    }), this.props.children);
  }
  ref(element) {
    this.tryRemoveMouseEventListeners();
    this._element = element;
    this.tryAddMouseEventListeners();
  }
  componentWillUnmount() {
    this.tryRemoveMouseEventListeners();
  }
  onMouseEnter() {
    this._isMouseOver = true;
  }
  onMouseLeave() {
    this._isMouseOver = false;
  }
  get isMouseOver() {
    return this._isMouseOver;
  }
  tryAddMouseEventListeners() {
    this._element?.addEventListener("mouseenter", this.onMouseEnter);
    this._element?.addEventListener("mouseleave", this.onMouseLeave);
  }
  tryRemoveMouseEventListeners() {
    this._element?.removeEventListener("mouseenter", this.onMouseEnter);
    this._element?.removeEventListener("mouseleave", this.onMouseLeave);
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "_isMouseOver", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "ref", [_dec], Object.getOwnPropertyDescriptor(_class2.prototype, "ref"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onMouseEnter", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "onMouseEnter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onMouseLeave", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "onMouseLeave"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isMouseOver", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isMouseOver"), _class2.prototype), _class2)) || _class);
//# sourceMappingURL=AbMouseOverListener.js.map
